module.exports = __webpack_public_path__ + "img/alcohol-intake-yes.47c6cd6e.svg";